/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Delete_ConfirmInputs */

const en_lifecycle_delete_confirm = /** @type {(inputs: Lifecycle_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const de_lifecycle_delete_confirm = /** @type {(inputs: Lifecycle_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Lifecycle_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_delete_confirm = /** @type {((inputs?: Lifecycle_Delete_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Delete_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_delete_confirm(inputs)
	return en_lifecycle_delete_confirm(inputs)
});